import useSharedSelectData from "@/use/SharedSelectData.js";

export default function useSharedControlProgram() {

    const controlModules = [
        {id: 'contrat', name: 'Contrat'},
        {id: 'worker', name: 'Employé'},
    ];
    const controlFieldTypes = [
        {id: 'date', name: 'Date'},
        {id: 'dateTime', name: 'Date et Temps'},
        {id: 'time', name: 'Temps'},
        {id: 'string', name: 'Chaine de Caratères'},
        {id: 'number', name: 'Nomber'},
        {id: 'boolean', name: 'Vari ou Faux'},
        {id: 'list', name: 'Liste'},
        {id: 'enum', name: 'Champ pré-définie'},
        // {id: 'STATIC', name: ''},
    ];
    const simpleControlOperators = [
        {id: 'equal', name: 'Egale'},
        {id: 'notEqual', name: 'Différent'},
        {id: 'lessThan', name: 'Infèrieur'},
        {id: 'lessThanOrEqualTo', name: 'Infèriieur ou Egale'},
        {id: 'greaterThan', name: 'Suppèrieur'},
        {id: 'greaterThanOrEqualTo', name: 'Suppèrieur ou Egale'},
    ];
    const controlOperators = [
        {id: 'equal', name: 'Egale'},
        {id: 'notEqual', name: 'Différent'},
        {id: 'lessThan', name: 'Infèrieur'},
        {id: 'lessThanOrEqualTo', name: 'Infèriieur ou Egale'},
        {id: 'greaterThan', name: 'Suppèrieur'},
        {id: 'greaterThanOrEqualTo', name: 'Suppèrieur ou Egale'},
        {id: 'between', name: 'Intervale Ouvrante'},
        {id: 'betweenLeftSideEqualTo', name: 'Intervale Fermer à Gauche'},
        {id: 'betweenRightSideEqualTo', name: 'Intervale Fermer à Droite'},
        {id: 'betweenBothSideEqualTo', name: 'Intervale Fermer'},
    ];
    const controlOptions = [];
    const controlPeriodicities = [
        {id: '', name: ''},
        {id: '', name: ''},
        {id: '', name: ''},
        {id: '', name: ''},
        {id: '', name: ''},
    ];

    function getDataSelectTag(listName) {
        switch (listName) {
            case 'cnasDeclarations':
                return 'CNAS_TYPE_DECLARATION';
            case 'mutualCompanies':
                return 'MUTUAL_COMPANY';
            case 'leavingCauses':
                return 'WORKER_EXIT_REASON';
            case    'companies':
                return 'WORKER_COMPANY'
            case    'workplaces':
                return 'WORKER_WORKPLACE'
            case    'states':
                return 'WORKER_STATE'
            case    'familySituations':
                return 'WORKER_FAMILY_SITUATION'
            case 'contratCharacteristics':
                return 'CONTRAT_NATURE'
        }
    }

    const {
        contratStatus,
        sexe,
        workerPhases,
        transferModes,
        profiles,
        modesIrg,
    } = useSharedSelectData();


    function getEnumList(listName) {
        switch (listName) {
            case 'contratStatus':
                return contratStatus;
            case 'sexe':
                return sexe;
            case 'phases':
                return workerPhases;
            case 'transferModes':
                return transferModes;
            case 'profiles':
                return profiles;
            case 'modesIrg':
                return modesIrg;
        }
    }


    return {
        controlModules,
        controlFieldTypes,
        simpleControlOperators,
        controlOperators,
        controlOptions,
        controlPeriodicities,
        getDataSelectTag,
        getEnumList,
    }
}